(function () {

  function updateSize(selectEl) {
    const descSize = document.getElementById('desc_size');
    if (!descSize || !selectEl) return;

    const selectedText =
      selectEl.options[selectEl.selectedIndex].text.trim();
      descSize.textContent = selectedText;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const select = document.querySelector('.product-form__single-selector');
    updateSize(select);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('product-form__single-selector')) {
      updateSize(e.target);
    }
  });
})();